export default "__VITE_ASSET__Bhc3fRUR__"